import React, { useEffect, useState } from "react";
import { getImageUrlCandidates } from "../../utils/resolveImageUrl";

const FallbackImage = ({
  src,
  alt = "",
  className = "",
  style,
  ...props
}) => {
  const candidates = getImageUrlCandidates(src);
  const [index, setIndex] = useState(0);
  const candidateKey = candidates.join("|");

  useEffect(() => {
    setIndex(0);
  }, [src, candidateKey]);

  if (!candidates.length || index >= candidates.length) {
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f3f0f7",
          color: "#9ca3af",
          fontSize: 10,
        }}
        aria-label={alt || "No image"}
      >
        No image
      </div>
    );
  }

  return (
    <img
      src={candidates[index]}
      alt={alt}
      className={className}
      style={style}
      onError={() => setIndex((current) => current + 1)}
      {...props}
    />
  );
};

export default FallbackImage;
